import { createClient } from "@hey-api/client-axios";

const serverFastApiClient = createClient({
  baseURL: process.env.FASTAPI_URL,
});

export default serverFastApiClient;
